/**
 * Validates a Chilean RUT (Rol Único Tributario)
 * Accepts formats: 12.345.678-9, 12345678-9, 123456789
 * Returns { valid: boolean, formatted: string, error: string }
 */
export function validateRut(rut) {
  if (!rut || rut.trim() === '') return { valid: true, formatted: '', error: '' }; // empty is ok (optional)

  // Clean: remove dots, dashes, spaces
  let cleaned = rut.replace(/[.\s]/g, '').toUpperCase();
  
  // Extract body and check digit
  let body, dv;
  if (cleaned.includes('-')) {
    const parts = cleaned.split('-');
    body = parts[0];
    dv = parts[1];
  } else {
    body = cleaned.slice(0, -1);
    dv = cleaned.slice(-1);
  }

  // Validate body is numeric and has between 6-8 digits
  if (!/^\d{6,8}$/.test(body)) {
    return { valid: false, formatted: rut, error: 'RUT debe tener entre 6 y 8 dígitos' };
  }

  // Validate check digit is a number or K
  if (!/^[0-9K]$/.test(dv)) {
    return { valid: false, formatted: rut, error: 'Dígito verificador inválido' };
  }

  // Calculate check digit using modulo 11
  let sum = 0;
  let multiplier = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  const remainder = 11 - (sum % 11);
  let expectedDv;
  if (remainder === 11) expectedDv = '0';
  else if (remainder === 10) expectedDv = 'K';
  else expectedDv = String(remainder);

  if (dv !== expectedDv) {
    return { valid: false, formatted: rut, error: `RUT inválido (dígito verificador debería ser ${expectedDv})` };
  }

  // Format: XX.XXX.XXX-Y
  const formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
  return { valid: true, formatted, error: '' };
}

/**
 * Validates RUT and returns true/false (simple check)
 */
export function isValidRut(rut) {
  return validateRut(rut).valid;
}
